import { QtmFormField, QtmTextInput } from '@qtm/react';
import { useAppDispatch } from 'hooks/redux';
import { setFilter, setPageIndex } from 'shared/reducers/usersTableSlice';

const UserDataTableFilter = () => {
  const dispatch = useAppDispatch();

  const onChange = (event: any) => {
    dispatch(setPageIndex(0));
    dispatch(setFilter(event.target.value));
  };

  return (
    <QtmFormField className="filter-user-action">
      <QtmTextInput left-icon="search" placeholder="Search" onValueChanged={onChange} />
    </QtmFormField>
  );
};

export default UserDataTableFilter;
